import script from "./paymentDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./paymentDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./paymentDetailModal.vue?vue&type=style&index=0&id=ecd36444&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecd36444"]])

export default __exports__